import { useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography
} from "@mui/material";
import axios from "axios";
import DebouncedOrderSearch from "../components/DebouncedOrderSearch";
import { FundingPackage } from "./types";
import { OrderInfo } from "../shared/orderInfo/types";
import { FundingAuthorizationContext } from "./FundingAuthorizationContext";
import { UserContext } from "../contexts/UserContext";
import { useNavigate } from "react-router-dom";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onCloseNewFundingPackageModal: () => void;
  orderNumberParam?: string;
}

const NewFundingPackageModal = ({ isOpen, setIsOpen, onCloseNewFundingPackageModal, orderNumberParam }: Props) => {
  const { user } = useContext(UserContext);
  const {fetchFundingPackages} = useContext(FundingAuthorizationContext)
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedOrderNumber, setSelectedOrderNumber] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [orderInfo, setOrderInfo] = useState<OrderInfo>();
  const navigate = useNavigate();
  
  const handleCloseModal = () => {
    setIsLoading(false);
    setIsOpen(false);
    onCloseNewFundingPackageModal();
  };
  const getAndSetOrderInfo = async () => {
    try {
      const { data } = await axios.get(`/proxy/api/orders/getOrderInfo?orderNumber=${selectedValue}`);
      setOrderInfo(data);
    } catch (error) {
      console.error("Failed to fetch order info:", error);
    }
  };

  const onSaveNewPackage = async () => {
    if (!selectedOrderNumber) {
      return; 
    }
    setIsLoading(true);
    const fundingPackage = {
        orderNumber: selectedOrderNumber
    }
    const {data} = await axios.post<FundingPackage>("/api/FundingPackages/packages/AddPackage", fundingPackage);
    setIsLoading(false);
    handleCloseModal();
    fetchFundingPackages();
    navigate(`/edit-funding-package/${data.orderNumber}-pkg${data.packageNumber}`);
    return data;

  };
useEffect(() => {
  if(orderNumberParam){
    setSelectedOrderNumber(orderNumberParam);
    setSelectedValue(orderNumberParam)
  }
},[selectedValue])
  useEffect(() => {
    if (selectedValue) {
      getAndSetOrderInfo();
    }
  }, [selectedValue]);

  return (
    <div>
      <Dialog open={isOpen} onClose={handleCloseModal} fullWidth>
        <DialogTitle variant="h4">
          Initiate New Funding Package
          <Typography variant="body2" color="text.secondary">
            Enter the Order Number to begin the funding request process.
          </Typography>
        </DialogTitle>
        <DialogContent>
          {
            <DebouncedOrderSearch
              value={selectedValue}
              textboxMargin="dense"
              onSelect={(e, option) => {
                setSelectedValue(option || "");
                setSelectedOrderNumber(option);
              }}
            />
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal}>Cancel</Button>
          <Button variant="contained" disabled={isLoading} onClick={onSaveNewPackage} >
            {isLoading ? <CircularProgress size={24} color="inherit" /> : "Start Package"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default NewFundingPackageModal;
